<template>
  <main class="row q-gutter-x-xs">
    <section class="col q-mr-md">
      <span
        class="text-weight-bolder"
        style="display: block; font-size: 16px; color: #21324a"
        >Unidades</span
      >
      <q-table
        style="max-height: 500px"
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :columns="columns"
        class="tabela-tamanho-fixo my-sticky-header-table"
        :rows-per-page-label="'Linhas Por Página'"
        :rows-per-page-options="[10, 25, 50, 100]"
        row-key="id"
        dense
        hide-bottom
        selection="multiple"
        v-model:selected="rows2"
        color="primary"
        v-model:pagination="pagination"
        @request="handleRequest"
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:top-left>
          <span style="display: block; margin-left: -15px; color: #21324a"
            >Unidades disponíveis para vincular ao usuário.</span
          >
        </template>
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:body="props">
          <q-tr>
            <q-td>
              <span>{{ props.row.name }}</span>
            </q-td>
            <q-td>
              <span>{{ props.row.contrato }}</span>
            </q-td>
            <q-td>
              <q-btn
                v-if="props"
                color="secondary"
                flat
                icon="sym_o_visibility"
                :disable="props.selected"
                round
                @click="vizualizarUnidade(props.row.id)"
              />
            </q-td>
            <q-td>
              <q-btn
                v-if="props"
                flat
                color="positive"
                icon="sym_o_done_outline"
                round
                @click="finalizarUnidade(props.row.id)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </section>
    <q-separator vertical />
    <section class="col q-ml-md">
      <q-table
        style="max-height: 500px"
        flat
        dense
        table-header-class="bg-accent text-width-bold"
        :rows="rows2"
        :loading="disable"
        :columns="columns2"
        class="q-mt-lg tabela-tamanho-fixo my-sticky-header-table"
        hide-bottom
        row-key="id"
        color="primary"
        :rows-per-page-label="'Linhas Por Página'"
        :rows-per-page-options="[10, 25, 50, 100]"
        :filter="filtrar2"
      >
        <template v-slot:top-left>
          <span style="display: block; margin-left: -15px; color: #21324a"
            >Unidades vinculadas ao usuário.</span
          >
        </template>
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar2"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>

        <template #body-cell-nome="props">
          <q-td>
            {{ props.row.name }}
          </q-td>
        </template>
        <template #body-cell-remover="props">
          <q-td>
            <q-btn
              v-if="props"
              color="negative"
              flat
              icon="sym_o_delete"
              round
              @click="removerUnidade(props.row.id)"
            />
          </q-td>
        </template>

        <template #body-cell-finalizar="props">
          <q-td>
            <span v-if="props.row.pivot.finish == 1">SIM</span>
            <span v-else>NÃO</span>
          </q-td>
        </template>
      </q-table>
    </section>
  </main>
</template>

<script setup>
const columns = [
  {
    name: "name",
    label: "Nome",
    field: "id",
    align: "left",
  },
  {
    name: "contrato",
    label: "Contrato",
    field: "name",
    align: "left",
  },
  {
    name: "visualizar",
    label: "Visualizar",
    field: "vizualizar",
    align: "left",
  },
  {
    name: "finalizar",
    label: "Finalizar",
    field: "finalizar",
    align: "left",
  },
];

const columns2 = [
  {
    name: "name",
    label: "Nome",
    field: "id",
    align: "left",
  },
  {
    name: "nome",
    label: "Contrato",
    field: "name",
    align: "left",
  },

  {
    name: "finalizar",
    label: "Finalizar",
    field: "finalizar",
    align: "left",
  },

  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { defineProps } from "vue";

import { ref, onMounted, computed, watch } from "vue";

const store = useStore();
const disable = ref(true);
const rows = ref([]);
const rows2 = ref([]);

const filtrar = ref("");
const filtrar2 = ref("");
const quasar = useQuasar();

const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 10,
  rowsNumber: 15,
});

const props = defineProps({
  id: {
    type: Number,
  },
});

const userId = computed(() => props.id);

const getUnidades = async (page = 0, rowsPerPage = 15) => {
  disable.value = true;
  try {
    let response = await store.dispatch("user/getUnidades", {
      vendor_id: store.state.org.unidadeData.id,
      page,
      search: filtrar.value,
      per_page: rowsPerPage,
    });

    rows.value = response.data.results.data;

    pagination.value.page = response.data.results.current_page;
    pagination.value.rowsPerPage = response.data.results.per_page;
    pagination.value.rowsNumber = response.data.results.total;

    disable.value = false;
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro a o procurar dados",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

onMounted(getUnidades);

const getUnidadesUser = async () => {
  disable.value = true;
  try {
    let response = await store.dispatch("user/getUserEspecifico", {
      id: userId.value,
    });

    rows2.value = response.data.model.vendors;

    disable.value = false;
  } catch (error) {
    console.log(error);
    quasar.notify({
      message: "Erro a o procurar dados",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

onMounted(getUnidadesUser);

const vizualizarUnidade = async (vendor_id) => {
  try {
    await store.dispatch("user/vincularUnidade", {
      id: userId.value,
      vendor_id,
      finish: 0,
    });
    quasar.notify({
      message: "Unidade vinculada com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    getUnidades();
    getUnidadesUser();
  } catch (error) {
    quasar.notify({
      message: "Erro a o modificar unidade",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const finalizarUnidade = async (vendor_id) => {
  try {
    await store.dispatch("user/vizualizarFinalizarUnidades", {
      id: userId.value,
      vendor_id,
      finish: 1,
    });

    getUnidades();
    getUnidadesUser();
    quasar.notify({
      message: "Unidade finalizada com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    quasar.notify({
      message: "Erro a o modificar unidade",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const removerUnidade = async (vendor_id) => {
  try {
    await store.dispatch("user/removerUnidade", {
      id: userId.value,
      vendor_id,
    });

    getUnidades();
    getUnidadesUser();
    quasar.notify({
      message: "Unidade removida com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  } catch (error) {
    quasar.notify({
      message: "Erro a o modificar unidade",
      color: "negative",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
  }
};

const handleRequest = async (props) => {
  getUnidades(props.pagination.page, props.pagination.rowsPerPage);
};

watch(
  () => filtrar.value,
  () => {
    getUnidades();
  }
);

watch(
  () => store.state.org.unidadeData.id,
  () => {
    getUnidades();
  }
);
</script>

<style lang="sass">
.my-sticky-header-table
  /* height or max-height is important */
  max-height: 500px


  thead tr:first-child th
    /* bg color is important for th; just specify one */
    background-color: #EEF3FE

  thead tr th
    position: sticky
    z-index: 1
  thead tr:first-child th
    top: 0

  /* this is when the loading indicator appears */
  &.q-table--loading thead tr:last-child th
    /* height of all previous header rows */
    top: 48px

  /* prevent scrolling behind sticky top row on focus */
  tbody
    /* height of all previous header rows */
    scroll-margin-top: 48px
</style>
